<ng-template #contentEstimation let-modal>
    <div class="modal-header container border-0 pt-3">
        <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <h4 class="text-uppercase text-center fw-normal">2 SOLUTIONS POUR ESTIMER VOTRE BIEN...</h4>
        <div class="row g-2 text-white">
            <div class="col-sm-6">
                <div class="card card-bleu-50 p-4 text-white">
                    <div class="mb-2">
                        <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4856_40980)">
                                <path
                                    d="M38.7472 49.1957C38.1872 49.6157 37.5972 50.0057 36.9872 50.3657C35.1572 51.4857 33.1472 52.3557 30.9672 52.9457C18.5172 56.3157 5.67721 48.9457 2.30721 36.4857C-0.472792 26.1257 4.13721 15.5257 12.9172 10.3057C14.7072 9.2357 16.6672 8.39569 18.7772 7.81569C20.8872 7.23569 23.2172 6.95569 25.3972 7.00569C25.6072 7.00569 25.8072 7.01569 26.0072 7.02569C35.8672 7.48569 44.7372 14.2157 47.4472 24.2657C47.7272 25.2857 47.9272 26.3257 48.0572 27.3457C48.1472 28.0257 48.2072 28.6957 48.2172 29.3757"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M69.1172 37.3657H38.8972V63.9157H69.1172V37.3657Z" stroke="white"
                                    stroke-width="2" stroke-miterlimit="10" />
                                <path d="M68.6572 43.4457H39.3572" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M42.1772 52.3457H45.9372" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M48.8472 52.3457H52.6072" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M55.5173 52.3457H59.2773" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M62.0773 52.3457H65.8373" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M42.1772 60.1057H45.9372" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M48.8472 60.1057H52.6072" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M55.5173 60.1057H59.2773" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M62.0773 60.1057H65.8373" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M42.1772 56.2256H45.9372" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M48.8472 56.2256H52.6072" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M55.5173 56.2256H59.2773" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M62.0773 56.2256H65.8373" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M42.1772 48.4657H45.9372" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M48.8472 48.4657H52.6072" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M55.5173 48.4657H59.2773" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M62.0773 48.4657H65.8373" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path
                                    d="M60.0572 40.3657C58.7972 40.3657 57.7772 39.2457 57.7772 37.8557V36.8757C57.7772 35.4857 57.6472 34.3657 58.9072 34.3657H60.1272"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path
                                    d="M50.1772 40.3657C48.9172 40.3657 47.8972 39.2457 47.8972 37.8557V36.8757C47.8972 35.4857 47.7672 34.3657 49.0272 34.3657H50.2472"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path
                                    d="M38.5972 11.9156C38.5972 11.9156 35.9872 24.1256 24.9772 31.4656L22.4572 33.1456C21.6472 33.6856 21.1572 34.5956 21.1572 35.5656V53.4156"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M11.3472 11.9156C11.3472 11.9156 13.9572 24.1256 24.9672 31.4656"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M22.5072 13.6457L19.4572 26.7457" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path d="M30.8271 26.3757L27.8271 13.4957" stroke="white" stroke-width="2"
                                    stroke-miterlimit="10" />
                                <path
                                    d="M16.6772 31.4756H8.79721C8.64257 31.4756 8.51721 31.601 8.51721 31.7556V35.1456C8.51721 35.3003 8.64257 35.4256 8.79721 35.4256H16.6772C16.8319 35.4256 16.9572 35.3003 16.9572 35.1456V31.7556C16.9572 31.601 16.8319 31.4756 16.6772 31.4756Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M26.791 37.9835L25.3556 36.548L23.9202 37.9835L25.3556 39.4189L26.791 37.9835Z"
                                    fill="white" />
                                <path
                                    d="M26.7853 43.5591L25.3499 42.1237L23.9144 43.5591L25.3499 44.9946L26.7853 43.5591Z"
                                    fill="white" />
                                <path
                                    d="M26.7897 49.1448L25.3542 47.7094L23.9188 49.1448L25.3542 50.5802L26.7897 49.1448Z"
                                    fill="white" />
                                <path
                                    d="M32.0671 7.52569C31.7271 11.2157 28.8371 14.8357 25.3271 14.8357C21.8171 14.8357 18.7971 11.0457 18.5771 7.26569"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            </g>
                            <defs>
                                <clipPath id="clip0_4856_40980">
                                    <rect width="70" height="70" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <h5 class="fw-semibold">Estimation <span style="color:#BADFFF">par un Conseiller</span> </h5>
                    <ul>
                        <li>Questionnaire rapide en ligne</li>
                        <li> <span class="fw-semibold">Réponse sur-mesure </span>par un Conseiller</li>
                        <li>Gratuit et sans engagement !</li>
                    </ul>
                    <app-modal-estimation-rdv [localityInput]="locality"></app-modal-estimation-rdv>
                </div>
            </div>
            <div class=" col-sm-6">
                <div class="card card-bleu-100 p-4 text-white">
                    <div class="mb-2">
                        <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M42.0801 26.5H66.5201C67.0601 26.5 67.4701 26.98 67.3801 27.51L62.7201 56.06H19.0901C18.5501 56.06 18.1501 55.58 18.2301 55.06L21.6801 33.93"
                                stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path
                                d="M3 56.41H62.72V60.31C62.72 62.65 60.82 64.55 58.48 64.55H6.32C4.49 64.55 3 63.06 3 61.23V56.41V56.41Z"
                                stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path
                                d="M14.6 33.93H40.13C40.56 33.93 40.92 33.62 40.99 33.2L43.66 16.87C43.75 16.34 43.34 15.86 42.8 15.86H17.26C16.83 15.86 16.47 16.17 16.4 16.59L13.73 32.92C13.64 33.45 14.05 33.93 14.59 33.93H14.6Z"
                                stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path
                                d="M39.74 52.03H57.5C57.65 52.03 57.78 51.93 57.83 51.79L58.89 46.61C58.96 46.39 58.8 46.16 58.56 46.16H40.8C40.65 46.16 40.52 46.26 40.47 46.4L39.41 51.58C39.34 51.8 39.5 52.03 39.74 52.03V52.03Z"
                                stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path d="M25.7 40.2H53.6199" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path d="M24.24 45.82H37.06" stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path d="M42.4199 56.24V60.06C42.4199 62.52 40.4199 64.52 37.9599 64.52H36.5699"
                                stroke="white" stroke-width="2" stroke-miterlimit="10" />
                            <path d="M9.92993 9.02002L14.8699 13.69" stroke="white" stroke-width="2"
                                stroke-miterlimit="10" />
                            <path d="M5.94995 18.65L12.75 18.46" stroke="white" stroke-width="2"
                                stroke-miterlimit="10" />
                            <path d="M19.5499 5.03003L19.7399 11.83" stroke="white" stroke-width="2"
                                stroke-miterlimit="10" />
                        </svg>

                    </div>
                    <h5 class="fw-semibold">Pré-estimation <span style="color:#BADFFF">en ligne</span> </h5>
                    <ul>
                        <li>Une première <span class="fw-semibold">estimation instantanée </span></li>
                        <li> Simple, rapide et fiable</li>
                        <li>En partenariat avec jestimo</li>
                    </ul>
                    <div>
                        <button type="button" class="btn btn-outlined  mb-2 me-2" (click)="accessToTool()"> Accéder à l’outil</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<button type="button" class="btn btn-gold mb-2 me-2" (click)="openVerticallyCentered(contentEstimation)" *ngIf="!hideBtnOpen">Estimer votre
    bien</button>
